import axios from 'axios';

const axiosInstanceV3 = axios.create({
  baseURL: 'https://bogir.hu/V3/',
  auth: {
    username: 'Admin_2024$$',
    password: 'S3cure+P@ssw0rd2024!'
  },
  headers: {
    'Content-Type': 'application/json'
  }
});

export default axiosInstanceV3;
